import { Chart, Separator as TWSeparator } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';

import DefaultActions from './Actions';
import Search from './Search';
import Wrapper from './Wrapper';

export { Search, Wrapper, DefaultActions }

export default function DefaultHeading({ children = <DefaultActions /> }) {
  return <Wrapper>
    <Search />
    <Separator />
    <Total />
    <Showing />
    <Active />
    <Separator />
    {children}
  </Wrapper>
}

export function Total() {
  const { store: { collections: { total } } } = useGrid()
  return <ResponsiveChart text='Total' value={total} />
}

export function Showing() {
  const { store: { collections: { items, total } } } = useGrid()
  return <ResponsiveChart text='Showing' value={items.length} total={total} color='warning' />
}

export function Active() {
  const { store: { collections: { actives, total } } } = useGrid()
  return <ResponsiveChart text='Active' value={actives} total={total} color='success' />
}

export function Separator() {
  return <TWSeparator orientation='vertical' className='py-5' />
}

function ResponsiveChart(props) {
  return <>
    <Chart {...props} size='md' className='md:hidden' total={undefined} />
    <Chart {...props} className='hidden md:flex' />
  </>
}
